import React from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Box,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import { getPointerEventsStyles, getReadOnlyStyles } from "../../lib/styles";
import { EXCLUSIVE_CHECKBOX_GROUPS } from "../../lib/constants";

export function CheckboxInput({ fieldConfig, controllerField, fieldState }) {
  const { readOnly, exclusiveGroup, optionLabels } = fieldConfig || {};
  const { name, value, onChange, ...rest } = controllerField;
  const form = useFormContext();

  // Allow multiple key styles for convenience: { true/false/none } or { yes/no/none }
  const trueLabel = optionLabels?.trueLabel ?? optionLabels?.trueLabel ?? "Yes";
  const falseLabel =
    optionLabels?.falseLabel ?? optionLabels?.falseLabel ?? "No";
  const noneLabel = optionLabels?.nullLabel ?? "None";

  const resolveLabel = (v) => {
    if (v === true) return trueLabel;
    if (v === false) return falseLabel;
    return <i>{noneLabel}</i>;
  };

  const handleChange = (checked) => {
    if (exclusiveGroup && checked) {
      const groupFields = EXCLUSIVE_CHECKBOX_GROUPS[exclusiveGroup] || [];
      groupFields.forEach((field) =>
        form.setValue(field, field === name, {
          shouldValidate: true,
          shouldDirty: true,
        })
      );
      form.trigger(groupFields);
    } else {
      onChange(checked);
    }
  };

  return (
    <FormControl error={!!fieldState.error} component="fieldset" fullWidth>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{ ...getReadOnlyStyles(readOnly), ml: 1 }}
      >
        <FormControlLabel
          label={resolveLabel(value)}
          sx={getPointerEventsStyles(readOnly)}
          control={
            <Checkbox
              {...rest}
              disabled={readOnly}
              checked={Boolean(value)}
              onChange={(e) => handleChange(e.target.checked)}
              sx={getReadOnlyStyles(readOnly)}
              inputProps={{ "aria-label": resolveLabel(value) }}
            />
          }
        />
      </Box>
      {!!fieldState.error && (
        <FormHelperText>{fieldState.error.message}</FormHelperText>
      )}
    </FormControl>
  );
}
